import { Component, Input, OnInit } from "@angular/core";
import { UploadFile } from "@services";
import { AddressDto, ContactDto, CustomerMasterDto, JobDto, MachineMasterDto } from "@shared/models";

@Component({
  selector: "abi-customer-confirm",
  templateUrl: "./create-confirm.component.html",
  styleUrls: ["./create-confirm.component.scss"]
})
export class CustomerCreateConfirmComponent implements OnInit{
  @Input() customer: CustomerMasterDto;
  @Input() job: JobDto;
  contact: ContactDto;
  address: AddressDto;
  machine: MachineMasterDto;
  @Input() files: UploadFile[];

  ngOnInit(): void {
    if (this.customer.contacts.length){
      this.contact = this.customer.contacts[0];
    }
    if (this.customer.addresses?.length){
      this.address = this.customer.addresses[0];
    }
    if (this.customer.machines.length){
      this.machine = this.customer.machines[0];
    }
  }

  getFileNames(fileList: UploadFile[]): string[] {
    return fileList && fileList.map(file => {
      return file.file.name;
    }) || [];
  }
}
